module.exports = __webpack_public_path__ + "static/cheeto-red-bf61f880eacc82d18583b68d8c62fba8.png";